import { fetchPOST } from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_FILES = "files";
const BASE_URL = "/api/files";

const fileQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const FILE_EMPTY = {file:"",files:[]};

export function useFileMutations() {

    async function uploadFileFunction(file){
        return await fetchPOST(`${BASE_URL}`,file,true)
    }
    return {
        uploadFile:useMyMutation(uploadFileFunction,REACT_QUERY_ID_FILES, file => `file ${file.title} created`),
    };

}